module.exports = __webpack_public_path__ + "img/teamImg5.531348e1.jpg";